import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import entity, { initialState as initialEntity } from "data/entity";

import assets, { initialState as initialAssets } from "data/assets";

import user, { initialState as initialUser } from "data/user";

import givingReducer from "data/giving-form";

import launcherReducer, {
  initialState as initialLauncher,
} from "data/giving-form-launcher/reducers";

import spreedly, { initialState as initialSpreedly } from "data/spreedly";

export const initialState = {
  entity: initialEntity,
  assets: initialAssets,
  user: initialUser,
  spreedly: initialSpreedly,
  launcher: initialLauncher,
};

export default (asyncReducers) => {
  return combineReducers({
    entity,
    assets,
    user,
    form: formReducer,
    giving_form: givingReducer,
    launcher: launcherReducer,
    spreedly,
    ...asyncReducers,
  });
};
